import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import frCommon from "./locales/fr/common.json";
import frErrors from "./locales/fr/errors.json";
import frAuth from "./locales/fr/auth.json";
import frUsers from "./locales/fr/users.json";
import frPatients from "./locales/fr/patients.json";
import frStudies from "./locales/fr/studies.json";
import frSurveys from "./locales/fr/surveys.json";
import frSettings from "./locales/fr/settings.json";
import frAnalysis from "./locales/fr/analysis.json";
import enCommon from "./locales/en/common.json";
import enErrors from "./locales/en/errors.json";
import enAuth from "./locales/en/auth.json";
import enUsers from "./locales/en/users.json";
import enPatients from "./locales/en/patients.json";
import enStudies from "./locales/en/studies.json";
import enSurveys from "./locales/en/surveys.json";
import enSettings from "./locales/en/settings.json";
import enAnalysis from "./locales/en/analysis.json";

/**
 * Clinician-facing catalogue. Deliberately separate from
 * apps/mobile/src/translations — patient copy and clinician copy share no
 * vocabulary, and there is no packages/i18n to hang shared strings on.
 *
 * Statically imported: two languages of small JSON is far cheaper than an
 * HTTP backend plus the loading state it forces on every screen.
 */
export const resources = {
  fr: { common: frCommon, errors: frErrors, auth: frAuth, users: frUsers, patients: frPatients, studies: frStudies, surveys: frSurveys, settings: frSettings, analysis: frAnalysis },
  en: { common: enCommon, errors: enErrors, auth: enAuth, users: enUsers, patients: enPatients, studies: enStudies, surveys: enSurveys, settings: enSettings, analysis: enAnalysis },
} as const;

export const SUPPORTED_LANGUAGES = ["fr", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr",
    supportedLngs: SUPPORTED_LANGUAGES,
    // "fr-FR" and "fr-CA" both resolve to "fr"; we do not ship regional
    // variants and do not want i18next probing for them.
    load: "languageOnly",
    nonExplicitSupportedLngs: true,
    defaultNS: "common",
    ns: ["common", "errors", "auth", "users", "patients", "studies", "surveys", "settings", "analysis"],
    detection: {
      // localStorage ONLY — deliberately not "navigator". Each deployment
      // serves one facility, and the first is French; a clinician on an
      // en-US-configured browser should still land in French. An explicit
      // choice in the language switcher persists and wins.
      order: ["localStorage"],
      lookupLocalStorage: "procare.lang",
      caches: ["localStorage"],
    },
    // React already escapes.
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export default i18next;
